import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './autentication-context.component';

interface NavbarProps {
    onLogout: () => void;
}

const AppNavbar: React.FC<NavbarProps> = ({ onLogout }) => {
    const { firstName } = useAuth(); //Get de logged employee
    const [expanded, setExpanded] = useState(false);

    const navigate = useNavigate();

    const handleNavigate = (path: string) => {
        setExpanded(false); // Close the hamburger menu when clicking an option
        navigate(path);
    };

    const handleLogoutClick = () => {
        setExpanded(false);
        onLogout();
    };
    return (
        <Navbar bg="light" expand="lg" className="mb-4 shadow-sm" expanded={expanded}>
            <Container>
                <Navbar.Brand>
                    Welcome {firstName}!
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : true)} />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link onClick={() => handleNavigate('/home')} >Home <i className="bi bi-house"></i></Nav.Link>
                        <Nav.Link onClick={() => handleNavigate('/accounts')}>Accounts <i className="bi bi-bank"></i></Nav.Link>
                        <Nav.Link onClick={() => handleNavigate('/mywages')}>Get Paid <i className="bi bi-coin"></i></Nav.Link>
                        <Nav.Link onClick={() => handleNavigate('/history')}>History <i className="bi bi-clock-history"></i></Nav.Link>
                        <Nav.Link onClick={() => handleNavigate('/profile')}>Profile <i className="bi bi-person-circle"></i></Nav.Link>
                    </Nav>
                    <Button variant="outline-danger" onClick={handleLogoutClick}>
                        Logout
                        <i className="bi bi-box-arrow-right ms-2"></i>
                    </Button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;